<template>
    <p @click="onClick"
        v-if="urls.length">
        <v-viewer v-if="showPreview && !disabled"
            ref="viewer"
            :options="options"
            :images="urls"
            @inited="onInited">
            <template slot-scope="scope">
                <base-img v-for="src in scope.images"
                    class="preview-img-base"
                    :src="src"
                    :key="src">
                </base-img>
            </template>
        </v-viewer>
    </p>
    <v-viewer v-else>
        <base-img v-for="(src, index) in list"
            class="preview-img-base"
            v-bind="$attrs"
            :src="src"
            :key="index">
        </base-img>
    </v-viewer>
</template>
<script>
import BaseImg from "_c/base-img"
import Viewer from "./viewer"

// 图片预览
export default {
    name: "ImgPreview",
    inheritAttrs: false,
    components: {
        BaseImg,
        "v-viewer": Viewer
    },

    props: {
        current: {
            type: String
        },
        urls: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false
        },
        list: {
            type: Array,
            default: () => []
        },
    },

    data() {
        return {
            showPreview: false,
            // Viewer 配置项
            options: {
                navbar: false,
                fullscreen: false,
                $viewer: null
            },
            inited: false
        }
    },

    watch: {
        urls: {
            handler: function() {
                this.showPreview = false
            }
        }
    },

    methods: {
        // click触发
        onClick() {
            this.show()
        },

        // viewer初始化
        onInited(viewer) {
            this.inited = true
            this.$viewer = viewer
            this.showCurrent()
        },

        // 显示预览界面
        show() {
            if (this.disabled) return

            this.showPreview = true

            //如果$viewer已创建, 直接显示
            if (this.inited) {
                this.showCurrent()
            }
        },

        showCurrent() {
            if (this.showPreview && this.urls.length) {
                let index = this.urls.findIndex(el => el === this.current) || 0

                this.$refs.viewer.$el
                    .querySelectorAll(".preview-img-base")
                    [index].click()
            }
        }
    }
}
</script>